export enum CloseReasonsEnum {
    COMPLETED = 'completed',
    TRIGGER = 'trigger',
}
